// src/Components/ThankYouPage/ThankYou.js  (or your preferred path)
import React, { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import styles from './ThankYou.module.css';
import { ReactComponent as CheckmarkSVG } from './checkmark-animated.svg'; // Adjust path if needed

function ThankYou() {
  const location = useLocation();
  const { applicantName, orderId, paymentId } = location.state || {}; // Destructure with defaults

  useEffect(() => {
    // Optional: Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={styles.thankYouPageWrapper}>
      <div className={styles.thankYouContentBox}>
        <div className={styles.animationContainer}>
          <CheckmarkSVG className={styles.checkmarkSvgAnimated} />
        </div>

        <h1 className={styles.thankYouHeading}>Thank You!</h1>
        
        {applicantName ? (
          <p className={styles.thankYouMessage}>
            Dear <span className={styles.applicantName}>{applicantName}</span>, your application has been submitted successfully.
          </p>
        ) : (
          <p className={styles.thankYouMessage}>
            Your application has been submitted successfully.
          </p>
        )}

        <p className={styles.followUpMessage}>
          We have received your details and will reach out to you shortly.
        </p>

        {orderId && paymentId && (
          <div className={styles.referenceDetails}>
            <p><strong>Order ID:</strong> {orderId}</p>
            <p><strong>Payment ID:</strong> {paymentId}</p>
          </div>
        )}

        <div className={styles.actions}>
          <Link to="https://apex.ac.in/" className={styles.homeButton}>
            Go to Homepage
          </Link>
          {/* You could add other relevant links here, e.g., "Track Application" if you have such a feature */}
        </div>
      </div>
    </div>
  );
}

export default ThankYou;